import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/ActivitiesInternalResource.ts
var n = class n extends t {
	static {
		this.getBaseUrl = () => `/rest/organizations/${e.orgPlaceholder}/activities`;
	}
	static {
		this.getBaseUrlAllOrgs = () => "/rest/activities";
	}
	async create(e) {
		return (await this.api.post(`${n.getBaseUrl()}/create`, e)).id;
	}
	async createError(e) {
		return (await this.api.post(`${n.getBaseUrl()}/create/error`, e)).id;
	}
	listFacets(e, t, r = !1, i = !1) {
		let a = r ? n.getBaseUrlAllOrgs() : n.getBaseUrl(), o = r || i || !!t?.sections?.includes("INTERNAL");
		return this.api.post(this.buildPath(o ? `${a}/facets` : `${a}/facets/public`, e), t);
	}
	listLatest(e, t) {
		return this.api.post(this.buildPath(`${n.getBaseUrl()}/latest`, e), t);
	}
	listBySubscriptions(e, t) {
		return this.api.post(this.buildPath(`${n.getBaseUrl()}/subscriptions/me`, e), t);
	}
};
//#endregion
export { n as ActivitiesInternalResource };

//# sourceMappingURL=ActivitiesInternalResource.js.map